import { gql } from "@apollo/client";
import exp from "constants";

export const GET_TAGS_FOR_SELECT = gql`
  query GET_TAGS_FOR_SELECT {
    findManyTag {
      id
      product_containers {
        id
      }
      tag_profiles {
        id
        name
        language
      }
    }
  }
`;

export const DELETE_MANY_TAGS = gql`
  mutation DELETE_TAGS($ids: [Int!]!) {
    deleteManyTag(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const GET_TAGS = gql`
  query GET_TAGS(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [TagOrderByWithRelationInput!]
  ) {
    findManyTag(
      where: {
        tag_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      tag_profiles {
        id
        name
        language
      }
      product_containers {
        id
      }
      createdAt
      updatedAt
    }
    findManyTagCount(
      where: {
        tag_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`;

export const GET_TAG = gql`
  query GetTag($id: Int!) {
    findUniqueTag(where: { id: $id }) {
      id
      main_image {
        id
        src
      }
      tag_profiles {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
        }
      }
      product_containers {
        id
      }
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CREATE_TAG(
    $tag_profiles: [TagProfileCustomInput!]!
    $images: [String]
    $selected_products: [ProductContainerWhereUniqueInput]!
  ) {
    createNewTag(
      tag_profiles: $tag_profiles
      images: $images
      selected_products: $selected_products
    ) {
      id
    }
  }
`;

export const UPDATE_TAG = gql`
  fragment CoreTagData on Tag {
    id
    main_image {
      id
      src
    }
    tag_profiles {
      id
      name
      description
      language
      meta_information {
        id
        permalink
        meta_title
        meta_description
      }
    }
    product_containers {
      id
    }
  }

  mutation UPDATE_TAG(
    $where: TagWhereUniqueInput!
    $tag_profiles: [TagProfileCustomInput!]!
    $images: [String]
    $selected_products: [ProductContainerWhereUniqueInput]!
  ) {
    updateExistingTag(
      where: $where
      tag_profiles: $tag_profiles
      images: $images
      selected_products: $selected_products
    ) {
      ...CoreTagData
    }
  }
`;
